import Resource from 'Resources/Resource';
import config from '../../config';

const BASE_URL = `https://status.upsales.com/api/v2`;

const requestOpts = { withCredentials: false };

type Component = {
	id: string;
	status: string;
};

export type Page = {
	status: string;
};
export type Incident = {
	name: string;
	shortlink: string;
	// eslint-disable-next-line camelcase
	updated_at: string;
	// eslint-disable-next-line camelcase
	incident_updates: {
		body: string;
	}[];
};

class StatuspageResource extends Resource {
	constructor() {
		super('_');
	}

	_getUrl(path = '') {
		return `${BASE_URL}/${path}.json`;
	}

	getPage(): Promise<Page> {
		return this._getRequest('components', requestOpts).then(r => {
			const component = (r.data.components as Component[]).find(
				c => c.id === config.STATUSPAGE.componentId
			);
			return { status: component?.status ?? 'operational' };
		});
	}

	getUnresolvedIncidents(): Promise<Incident[]> {
		return this._getRequest('incidents/unresolved', requestOpts).then(r => r.data.incidents);
	}

	getScheduledIncidents(): Promise<Incident[]> {
		return Promise.all([
			this._getRequest('scheduled-maintenances/upcoming', requestOpts),
			this._getRequest('scheduled-maintenances/active', requestOpts)
		]).then(([upcoming, active]) => [
			...(upcoming.data.scheduled_maintenances ?? []),
			...(active.data.scheduled_maintenances ?? [])
		]);
	}
}

const resource = new StatuspageResource();

export default resource;
